<template>
    <div class="select-container" :class="{open: isOpen==true}" v-on-clickaway="away">
        <div class="select-input">
            <span class="fa fa-angle-down cross"></span>
            <input type="text" class="form-control form-control-sm"
                    ref="input"
                    :placeholder="place"
                    v-model="keyWord"
                    @focus="onFocus"
                    @keyup="onSearch"/>
        </div>
        <div class="select-dropdown vld-parent" ref="i100" style="min-height: 30px;">
            <table class="table-select">
                <tbody>
                    <tr v-if="isAddAll" @click="select(null)">
                        <td colspan="3">{{$t('all')}}</td>
                    </tr>
                    <tr v-for="(ret,index) in records" :key="index" @click="select(ret)">
                        <td>{{ret.Name}}</td>
                        <td class="text-right">{{ret.Phone}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { mixin as clickaway } from 'vue-clickaway';
    export default {
        mixins: [ clickaway ],
        props: {
            value: {
                type: String,
                default: ''
            },
            clear: {
                type: Boolean,
                default: false
            },
            place: {
                type: String,
                default: ''
            },
            isAll: {
                type: Boolean,
                default: false
            }
        },
        data: function(){
            return {
                keyWord: this.value,
                isOpen: false,
                records: [],
                isShow: false,
                isAddAll: this.isAll
            }
        },
        methods: {
            init(){
                var loading = this.$loading.show({
                    container: this.$refs.i100,
                    height: 25,
                    loader: 'dots'
                });
                var query = {
                    Text: this.keyWord,
                    Page: 1,
                    Limit: 25,
                    SortType: 'ASC',
                    SortField: 'Name'
                };
                this.$api().post('customer/list', query).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Data;
                        if(this.records.length > 0){
                            this.isShow = true;
                        }
                    }
                }).finally(function(){ loading.hide(); });
            },
            onFocus(){
                this.isOpen = true;
                    if(!this.isShow)
                        this.init();
            },
            away() {
                this.isOpen = false;
            },
            select(item){
                this.isOpen = false;
                if(item == null){
                    this.keyWord = '';
                }else{
                    this.keyWord = item.Name;
                }
                this.$emit('select', item);
            },
            onSearch(){
                this.init();
            }
        },
        watch: {
            value(val){
                this.keyWord = val;
            }
        }
    }
</script>